export const GET_ZONES_REQUEST = "GET_ZONES_REQUEST";
export const GET_ZONES_FAILURE = "GET_ZONES_FAILURE";
export const GET_ZONES_SUCCESS = "GET_ZONES_SUCCESS";
